// extracted by mini-css-extract-plugin
export default {"featuredContainer":"Shop_featuredContainer__MPJOV","content":"Shop_content__7JW22","imageCont":"Shop_imageCont__hsVbJ","shopBtn":"Shop_shopBtn__vESjv","heru":"Shop_heru__u6RpD"};